const PFitems = [
    {
        title: "June 2020 - Present (3 years 3 months)",
        cardTitle: "Finance Manager",
        cardSubtitle: "McMurray Aviation, Fort McMurray, Canada",
        cardDetailedText: [
            "🔹 Developed interactive dashboards and KPI reports for the key business data through Excel and MS Power BI to provide insightful analysis to the executives/shareholders",
            "🔹 Piloted first companywide analysis for budgeting, cost analysis, pricing models, and resource optimization to successfully meet organizational goals",
            "🔹 Initiated regular evaluation of key financial information related to performance metrics and drafted actionable recommendations to executive/shareholders",
            "🔹 Performed payroll and accounting duties including ‘When I Work’ audits, QuickBooks process & Employee work hours tracking/analytics (Reduced labor cost by 7%)",
        ],
    },
    {
        title: "May 2019 - May 2020 (1 year 1 month)",
        cardTitle: "Business Analyst",
        cardSubtitle: "McMurray Aviation, Fort McMurray, Canada",
        cardDetailedText: [
            "🔹 Brought automation and digitalization to several business processes through implementation and integration of various MS products like Teams, Forms, Approval, Automate, Inspections, Planner, Tasks etc.",
            "🔹 Streamlined internal processes through integrating data collection from various softwares such as When I Work, Skyline, GFO, and QuickBooks to establish a constructive internal reporting systems.",
            "🔹 Collaborated with dispatch, freight, and administrative teams to understand operation needs and processes to update non-performing methods and procedures.",
        ],
    },
    {
        title: "May 2018 - April 2019 (1 year)",
        cardTitle: "Office Optimizer",
        cardSubtitle: "McMurray Aviation, Fort McMurray, Canada",
        cardDetailedText: [
            "🔹 Conducted organization-wide internal audit relating to safety, training, administrative policy, maintenance",
            "🔹 Piloted first hazard prevention program and created a customized scientific hazard ranking system with dynamic excel dashboard",
            "🔹 Created in-house training material using digital tools and implemented a comprehensive tracking system to meet reoccurring training requirements",
            "🔹 Worked on a wide range of tasks: Google Analytics setup, Website optimization using online tools such as AdWords and WordPress SEO plugins, ran paid google & Facebook marketing campaigns",
        ],
    },
    {
        title: "May 2019 - May 2020 (1 year 1 month)",
        cardTitle: "Accounting Clerk/Technician",
        cardSubtitle: "Keyano College, Fort McMurray, Fort McMurray, Canada",
        cardDetailedText: [
            "🔹 Performed process implementation of invoices, expense claims and vendor reconciliations.",
            "🔹 Conducted monthly large cash audits for various departments",
            "🔹 Contributed to process optimization for budgeting and created variance reports (Excel dynamic budgeting system)",
            "🔹 Worked as a bridge between departments to ensure smooth regular government and inter-departmental reporting for receiving large government grants",
        ],
    },
    {
        title: "September 2018 - April 2019 (8 months)",
        cardTitle: "President",
        cardSubtitle:
            "Students' Association of Keyano College, Fort McMurray, Canada",
        cardDetailedText: [
            "🔹 Chair: Student Governing Board, Executive Council",
            "🔹 Student Member: Keyano College Board of Governors, Academic Council",
            "🔹 Official delegate: Alberta Students’ Executive Council (ASEC)",
            "🔹 Leadership: Student advocacy at various platforms",
            "🔹 Governance: Working actively to improve policies, by laws and procedures concerning students",
            "🔹 Communication: Re-established communications and relationships with the executive counterparts at Keyano College",
            "🔹 Operations: Successfully handled the operation of Lounge. Reduced the projected loss by nearly 60%.",
            "🔹 Finance: Successfully put the organization in the surplus from the proposed deficit",
            "🔹 Human Resource: Worked extensively to improve internal reporting, hiring – job posting to interview",
        ],
    },
    {
        title: "October 2017 - April 2018 (7 months)",
        cardTitle: "Store Supervisor",
        cardSubtitle: "Cellairis Mobile Shop",
        cardDetailedText: [
            "🔹 Prepared sales, inventory and daily operations reports and analysis",
            "🔹 Created work schedules and supervised worker performance by implementing KPIs",
            "🔹 Handled inventory management including inventory projections, analysis, and plans",
            "🔹 Direct customer merchandise selling, upselling experience",
        ],
    },
    {
        title: "September 2017 - April 2018 (8 months)",
        cardTitle: "Peer Tutor",
        cardSubtitle: "Keyano College, Fort McMurray",
        cardDetailedText: [
            "🔹 Helped students in multiple subjects relating to Business Math, Statistics, Computing, Business Organization, Management and Operations Management",
            "🔹 Provided healthy and enhanced learning opportunities for students using various online tools by implementing customized teaching strategies",
        ],
    },
    {
        title: "May 2017 - August 2017 (4 months)",
        cardTitle: "Visitor Services / Mobile Travel Councillor",
        cardSubtitle: "Fort McMurray Tourism, Fort McMurray, Canada",
        cardDetailedText: [
            "🔹 Gained widespread administrative and discovery gift shop work experience",
            "🔹 Represented tourism at various events and places around the community using unique promotion strategies",
            "🔹 Conducted over 1000 surveys, and generated survey reports using SurveyMonkey",
        ],
    },
    {
        title: "August 2016 - November 2016 (4 months)",
        cardTitle: "Junior Consultant",
        cardSubtitle: "Digital Media Group, Ahmedabad Area, India",
        cardDetailedText: [
            "🔹 Handled client meetings, projects, and start-to-end project-related communications",
            "🔹 Crafted digital strategies, SWOT Analysis, KPI and Objectives for clients",
            "🔹 Delivered best customer service with effective result of 90% repeat clients",
        ],
    },
    {
        title: "May 2016 - July 2016 (3 months)",
        cardTitle: "Operation & Marketing Intern",
        cardSubtitle: "Helping Homes Services",
        cardDetailedText: [
            "🔹  Reduced churn rate to around 46% from 98%, which is more than 50% improvement.",
            "🔹  Established Google webmaster, Google AdWords, Google Analytics and Facebook Ads accounts primarily. Generated first SEO report using online tools.",
            "🔹  Increased operation power and delivered through local marketing in both models; B2B and B2C.",
        ],
    },
];

export default PFitems;
